import APIDOC from '@/common/serverApi';
import { get, post, postFormData } from '@/common/request';

function request(commit, requestFn, endpoint, payload) {
    commit('STARTREQUEST', null, { root: true });
    return requestFn(endpoint, payload)
        .then((result) => {
            commit('ENDREQUEST', null, { root: true });
            return result;
        })
        .catch((error) => {
            commit('ENDREQUEST', null, { root: true });
            return Promise.reject(error);
        });
}

export default {
    namespaced: true,
    state: {},
    mutations: {},
    actions: {
        getCapabilities({ commit }, payload) {
            return request(commit, get, APIDOC.USER.getOnlineDefenseCapabilities, payload);
        },
        getList({ commit }, payload) {
            return request(commit, get, APIDOC.USER.getOnlineDefenseList, payload);
        },
        getInfo({ commit }, payload) {
            return request(commit, get, APIDOC.USER.getOnlineDefenseInfo, payload);
        },
        uploadMaterials({ commit }, payload) {
            return request(commit, postFormData, APIDOC.USER.uploadOnlineDefenseMaterial, payload);
        },
        deleteMaterial({ commit }, payload) {
            return request(commit, post, APIDOC.USER.deleteOnlineDefenseMaterial, payload);
        },
        getDeviceTest({ commit }, payload) {
            return request(commit, get, APIDOC.USER.getOnlineDefenseDeviceTest, payload);
        },
        getEntryUrl({ commit }, payload) {
            return request(commit, get, APIDOC.USER.getOnlineDefenseEntryUrl, payload);
        }
    }
};



// WEBPACK FOOTER //
// ./src/store/onlineDefense.js